import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UrlnavService } from './shared/urlnav.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  title = 'profanis-yt';
  link: any;
  isSticky = false;
  hiddenFooter = false;
  bgColor = 'gray'
  url:any
  sidebar: any;
  constructor(private navurlService: UrlnavService){}

  ngOnInit() {
    this.navurlService.data$.subscribe((data: any) => {
      this.url = data
      console.log(this.url)
    })
  }
  checkSideNav($event: any){
    this.sidebar = $event
  }
}
